import React from 'react';

export default (
        <svg viewBox="0 0 22 22" ><g fill="none" fillRule="evenodd"><g fill="#3E6AED" fillRule="nonzero" className="icon__fill"><g><path d="M13.062 6L12.26 6.802 15.828 10.37 4 10.37 4 11.504 15.828 11.504 12.26 15.072 13.062 15.873 17.999 10.937z" transform="translate(-587 -468) translate(587 468)"></path></g></g></g></svg>
);
